import React from 'react';
import { Link } from 'react-router-dom';
import { HelpCircle, MessageCircle, BookOpen, Phone, Mail, FileText } from 'lucide-react';

const Help = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Yardım Merkezi
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Size yardımcı olmak için buradayız. Sorularınızın cevaplarını burada bulabilirsiniz.
          </p>
        </div>

        {/* Yardım Kategorileri */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          <Link
            to="/shipping"
            className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow"
          >
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center mr-4">
                <FileText className="h-6 w-6 text-orange-600" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900">Kargo & Teslimat</h3>
            </div>
            <p className="text-gray-600">
              Sipariş takibi, teslimat süreleri ve kargo ücretleri hakkında bilgi alın.
            </p>
          </Link>

          <Link
            to="/returns"
            className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow"
          >
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mr-4">
                <HelpCircle className="h-6 w-6 text-blue-600" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900">İade & Değişim</h3>
            </div>
            <p className="text-gray-600">
              Ürün iade ve değişim süreci, şartları ve politikaları hakkında bilgi edinin.
            </p>
          </Link>

          <Link
            to="/faq"
            className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow"
          >
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mr-4">
                <MessageCircle className="h-6 w-6 text-green-600" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900">Sık Sorulan Sorular</h3>
            </div>
            <p className="text-gray-600">
              En çok sorulan soruların cevaplarını burada bulabilirsiniz.
            </p>
          </Link>

          <Link
            to="/contact"
            className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow"
          >
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mr-4">
                <Mail className="h-6 w-6 text-purple-600" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900">İletişim</h3>
            </div>
            <p className="text-gray-600">
              Bize ulaşın, sorularınızı sorun veya geri bildirimde bulunun.
            </p>
          </Link>

          <div className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow">
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 bg-yellow-100 rounded-lg flex items-center justify-center mr-4">
                <BookOpen className="h-6 w-6 text-yellow-600" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900">Kullanım Kılavuzu</h3>
            </div>
            <p className="text-gray-600">
              Sitemizi nasıl kullanacağınızı öğrenin, sipariş verme adımlarını görün.
            </p>
          </div>

          <div className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow">
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mr-4">
                <Phone className="h-6 w-6 text-red-600" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900">Canlı Destek</h3>
            </div>
            <p className="text-gray-600">
              Hemen destek almak için +90 538 316 14 62 numaralı telefonu arayın.
            </p>
          </div>
        </div>

        {/* Hızlı Bağlantılar */}
        <div className="bg-white rounded-lg shadow-md p-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">Hızlı Bağlantılar</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Link
              to="/shipping"
              className="text-orange-600 hover:text-orange-700 underline"
            >
              → Kargo ve Teslimat Bilgileri
            </Link>
            <Link
              to="/returns"
              className="text-orange-600 hover:text-orange-700 underline"
            >
              → İade ve Değişim Politikası
            </Link>
            <Link
              to="/faq"
              className="text-orange-600 hover:text-orange-700 underline"
            >
              → Sık Sorulan Sorular
            </Link>
            <Link
              to="/contact"
              className="text-orange-600 hover:text-orange-700 underline"
            >
              → Bize Ulaşın
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Help;








